import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"

export default function NotFoundPage(): JSX.Element {
  return (
    <Layout>
      <Seo title={'404 Not Found｜TRIAL -トライアル-'} />
      <section className="not-found">
        <h1 className="not-found__title">404 Not Found</h1>
        <p className="not-found__msg">
          お探しのページは見つかりませんでした。<br />
          一時的にアクセス出来ない状態か、移動もしくは削除された可能性があります。
        </p>
        <div className="not-found__link-wrapper">
          <Link to="/" className="not-found__link">
            <button className="not-found__btn">トップページ</button>
          </Link>
        </div>
      </section>
    </Layout>
  )
}
